// extracted by mini-css-extract-plugin
export var container = "TestimonialList-module--container--bi-3C";
export var testimonialGrid = "TestimonialList-module--testimonialGrid--2PbHB";
export var testimonialList1 = "TestimonialList-module--testimonialList1--3NenO";
export var testimonialList2 = "TestimonialList-module--testimonialList2--1MlSt";
export var show = "TestimonialList-module--show--1p9K1";
export var showFadeInDown = "TestimonialList-module--show-fade-in-down--3yV2l";
export var showFadeInUp = "TestimonialList-module--show-fade-in-up--3Q3OY";
export var hideFadeOut = "TestimonialList-module--hide-fade-out--21xYq";